<p-toast/>
<p-confirmPopup/>


<div class="card" style="min-height: 80vh;">
    <div class="flex w-full justify-content-between">
        <span style="font-size: 20px; font-weight: bold;">
            PARCEIROS
        </span>
        
        <div class="flex gap-2">

            <p-button icon="pi pi-filter" [disabled]="!loaded" label="Filtros" (onClick)="filtros.toggle($event)"></p-button>
    
            <p-overlayPanel #filtros appendTo="body" [style]="{'width': '20rem'}">
                <div class="flex flex-column gap-2 w-full">
                    <!-- Botão Toggle -->
                    <p-button  [disabled]="!loaded" icon="{{!showIsUnacitve ? 'pi pi-ban' : 'pi pi-check'}}" 
                        label="{{!showIsUnacitve ? 'Mostrar Inativos' : 'Mostrar Ativos'}}"
                        [severity]="!showIsUnacitve ? 'danger' : 'success'" styleClass="w-full" (onClick)="togglePartners()">
                    </p-button>
            
                    <!-- Botão Limpar -->
                    <p-button  [disabled]="!loaded" label="Limpar Filtros" severity="primary" outlined="true" styleClass="w-full" (onClick)="showIsUnacitve = false; ListPartners();"></p-button>
                </div>
            </p-overlayPanel>

            <p-button label="Adicionar" icon="pi pi-plus" (onClick)="displayAddPartner=!displayAddPartner"></p-button>
        </div>
    </div>

    <hr class="w-full my-3">

    <div style="margin-top: 1rem;">
        <p-table
            styleClass="p-datatable-gridlines p-datatable-striped"
            [tableStyle]="{ 'min-width': '30vh' }"
            [value]="partners"
            sortField="name"
            [sortOrder]="-1"
            [paginator]="partners.length == 0 ? false : true"
            [rows]="8"
            [globalFilterFields]="['name', 'cpfCnpj','email', 'phone', 'from', 'plan.address', 'hash']"
            >

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="name">Parceiro<p-sortIcon field="name"/> 
                    <th pSortableColumn="cpfCnpj">CpfCnpj<p-sortIcon field="cpfCnpj"/> 
                    <th pSortableColumn="email">Email<p-sortIcon field="email"/> 
                    <th pSortableColumn="phone">Telefone<p-sortIcon field="phone"/>
                    <th pSortableColumn="from">Origem<p-sortIcon field="from"/>
                    <th pSortableColumn="address">Endereço<p-sortIcon field="address"/>
                    <th pSortableColumn="hash">Identificador<p-sortIcon field="hash"/>
                    <th>Funções</th>
                </tr>
                <tr>
                    <th>
                        <p-columnFilter type="text" field="name" matchMode="contains" placeholder="Parceiro" ariaLabel="Filter Name" [showMenu]="false" [showClearButton]="false" />
                    </th>
                    <th>
                        <p-columnFilter type="text" field="cpfCnpj" matchMode="contains" placeholder="CPF/CNPJ" ariaLabel="Filter Name" [showMenu]="false" [showClearButton]="false" />
                    </th>
                    <th>
                        <p-columnFilter type="text" field="email" matchMode="contains" placeholder="Email" ariaLabel="Filter Name" [showMenu]="false" [showClearButton]="false" />
                    </th>
                    <th>
                        <p-columnFilter type="text" field="phone" matchMode="contains" placeholder="Telefone" ariaLabel="Filter Name" [showMenu]="false" [showClearButton]="false" />
                    </th>
                    <th>
                        <p-columnFilter type="text" field="from" matchMode="contains" placeholder="Origem" ariaLabel="Filter Name" [showMenu]="false" [showClearButton]="false" />
                    </th>
                    <th>
                        <p-columnFilter type="text" field="address" matchMode="contains" placeholder="Endereço" ariaLabel="Filter Address" [showMenu]="false" [showClearButton]="false" />
                    </th>
                    <th>
                        <p-columnFilter type="text" field="address" matchMode="contains" placeholder="Endereço" ariaLabel="Filter Address" [showMenu]="false" [showClearButton]="false" />
                    </th>
                    <th></th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-partner>
                <tr>

                    <!-- nome -->
                    <td>
                        <div class="flex align-items-center gap-2">
                            <ng-container *ngIf="editingCell?.id !== partner.id || editingCell?.field !== 'name'; else editName">
                                <span>{{ partner.name }}</span>
                                <button pButton icon="pi pi-pencil" 
                                    class="p-button-text p-button-sm"
                                    (click)="startEdit(partner, 'name')">
                                </button>
                            </ng-container>

                            <ng-template #editName>
                                <input pInputText [(ngModel)]="partner.name" class="w-full"/>
                                <button pButton icon="pi pi-check"
                                    class="p-button-text p-button-success p-button-sm"
                                    (click)="saveCell(partner)">
                                </button>
                                <button pButton icon="pi pi-times"
                                    class="p-button-text p-button-danger p-button-sm"
                                    (click)="cancelEdit(partner)">
                                </button>
                            </ng-template>
                        </div>
                    </td>

                    <!-- cpg/cnpj -->
                    <td>
                        <div class="flex align-items-center gap-2">
                            <ng-container *ngIf="editingCell?.id !== partner.id || editingCell?.field !== 'cpfCnpj'; else editCpfCnpj">
                                <span>{{ partner.cpfCnpj }}</span>
                                <button pButton icon="pi pi-pencil" 
                                    class="p-button-text p-button-sm"
                                    (click)="startEdit(partner, 'cpfCnpj')">
                                </button>
                            </ng-container>

                            <ng-template #editCpfCnpj>
                                <input pInputText [(ngModel)]="partner.cpfCnpj" class="w-full"/>
                                <button pButton icon="pi pi-check"
                                    class="p-button-text p-button-success p-button-sm"
                                    (click)="saveCell(partner)">
                                </button>
                                <button pButton icon="pi pi-times"
                                    class="p-button-text p-button-danger p-button-sm"
                                    (click)="cancelEdit(partner)">
                                </button>
                            </ng-template>
                        </div>
                    </td>

                    <!-- email -->
                    <td>
                        <div class="flex align-items-center gap-2">
                            <ng-container *ngIf="editingCell?.id !== partner.id || editingCell?.field !== 'email'; else editEmail">
                                <span>{{ partner.email }}</span>
                                <button pButton icon="pi pi-pencil" 
                                    class="p-button-text p-button-sm"
                                    (click)="startEdit(partner, 'email')">
                                </button>
                            </ng-container>

                            <ng-template #editEmail>
                                <input pInputText [(ngModel)]="partner.email" class="w-full"/>
                                <button pButton icon="pi pi-check"
                                    class="p-button-text p-button-success p-button-sm"
                                    (click)="saveCell(partner)">
                                </button>
                                <button pButton icon="pi pi-times"
                                    class="p-button-text p-button-danger p-button-sm"
                                    (click)="cancelEdit(partner)">
                                </button>
                            </ng-template>
                        </div>
                    </td>

                    <!-- tel -->
                    <td>
                        <div class="flex align-items-center gap-2">
                            <ng-container *ngIf="editingCell?.id !== partner.id || editingCell?.field !== 'phone'; else editPhone">
                                <span>{{ partner.phone }}</span>
                                <button pButton icon="pi pi-pencil" 
                                    class="p-button-text p-button-sm"
                                    (click)="startEdit(partner, 'phone')">
                                </button>
                            </ng-container>

                            <ng-template #editPhone>
                                <input pInputText [(ngModel)]="partner.phone" class="w-full"/>
                                <button pButton icon="pi pi-check"
                                    class="p-button-text p-button-success p-button-sm"
                                    (click)="saveCell(partner)">
                                </button>
                                <button pButton icon="pi pi-times"
                                    class="p-button-text p-button-danger p-button-sm"
                                    (click)="cancelEdit(partner)">
                                </button>
                            </ng-template>
                        </div>
                    </td>

                    <!-- origem -->
                    <td>
                        <div class="flex align-items-center gap-2">
                            <ng-container *ngIf="editingCell?.id !== partner.id || editingCell?.field !== 'from'; else editFrom">
                                <span>{{ partner.from }}</span>
                                <button pButton icon="pi pi-pencil" 
                                    class="p-button-text p-button-sm"
                                    (click)="startEdit(partner, 'from')">
                                </button>
                            </ng-container>

                            <ng-template #editFrom>
                                <input pInputText [(ngModel)]="partner.from" class="w-full"/>
                                <button pButton icon="pi pi-check"
                                    class="p-button-text p-button-success p-button-sm"
                                    (click)="saveCell(partner)">
                                </button>
                                <button pButton icon="pi pi-times"
                                    class="p-button-text p-button-danger p-button-sm"
                                    (click)="cancelEdit(partner)">
                                </button>
                            </ng-template>
                        </div>
                    </td>

                    <!-- endereço -->
                    <td>
                        <div class="flex align-items-center gap-2">
                            <ng-container *ngIf="editingCell?.id !== partner.id || editingCell?.field !== 'address'; else editAddress">
                                <span>{{ partner.address }}</span>
                                <button pButton icon="pi pi-pencil" 
                                    class="p-button-text p-button-sm"
                                    (click)="startEdit(partner, 'address')">
                                </button>
                            </ng-container>

                            <ng-template #editAddress>
                                <input pInputText [(ngModel)]="partner.address" class="w-full"/>
                                <button pButton icon="pi pi-check"
                                    class="p-button-text p-button-success p-button-sm"
                                    (click)="saveCell(partner)">
                                </button>
                                <button pButton icon="pi pi-times"
                                    class="p-button-text p-button-danger p-button-sm"
                                    (click)="cancelEdit(partner)">
                                </button>
                            </ng-template>
                        </div>
                    </td>

                    <!-- hash -->
                    <td>
                        <div class="flex align-items-center gap-2">
                            <ng-container *ngIf="editingCell?.id !== partner.id || editingCell?.field !== 'hash'; else editHash">
                                <span>{{ partner.hash }}</span>
                                <button pButton icon="pi pi-pencil" 
                                    class="p-button-text p-button-sm"
                                    (click)="startEdit(partner, 'hash')">
                                </button>
                            </ng-container>

                            <ng-template #editHash>
                                <input pInputText [(ngModel)]="partner.hash" class="w-full"/>
                                <button pButton icon="pi pi-check"
                                    class="p-button-text p-button-success p-button-sm"
                                    (click)="saveCell(partner)">
                                </button>
                                <button pButton icon="pi pi-times"
                                    class="p-button-text p-button-danger p-button-sm"
                                    (click)="cancelEdit(partner)">
                                </button>
                            </ng-template>
                        </div>
                    </td>


                    <td *ngIf="!showIsUnacitve">
                        <div class="flex gap-2">
                            <p-button icon="pi pi-link" [rounded]="true" [outlined]="true" severity="success" pTooltip="Gerar link" (onClick)="copyLink(partner)"></p-button>
                            <!-- <p-button icon="pi pi-search" [rounded]="true" [outlined]="true" severity="info"></p-button> -->
                            <p-button icon="pi pi-times" rounded outlined severity="danger" (onClick)="deleteOptions.show($event)"></p-button>

                            <p-overlayPanel #deleteOptions appendTo="body" [style]="{'width': '17rem'}">
                                <div class="flex flex-column gap-4 w-full">
                                    <div>
                                        <p>Deseja deletar este parceiro?</p>
                                    </div>
                                    <div class="flex flex-row gap-2">
                                        <p-button label="Sim" icon="pi pi-check" severity="danger" (onClick)="delete(partner); deleteOptions.hide()"></p-button>
                                        <p-button label="Não" icon="pi pi-times" outlined="true" (onClick)="deleteOptions.hide()"></p-button>
                                    </div>
                                </div>
                            </p-overlayPanel>
                        </div>
                    </td>

                    <td *ngIf="showIsUnacitve">
                        <div class="flex gap-2">
                            <p-button icon="pi pi-check-circle" rounded outlined severity="success" (onClick)="reactive.show($event)"></p-button>

                            <p-overlayPanel #reactive appendTo="body" [style]="{'width': '17rem'}">
                                <div class="flex flex-column gap-4 w-full">
                                    <div>
                                        <p>Deseja reativar este parceiro?</p>
                                    </div>
                                    <div class="flex flex-row gap-2">
                                        <p-button label="Sim" icon="pi pi-check" severity="success" (onClick)="reactivePartner(partner); reactive.hide()"></p-button>
                                        <p-button label="Não" icon="pi pi-times" outlined="true" (onClick)="reactive.hide()"></p-button>
                                    </div>
                                </div>
                            </p-overlayPanel>
                        </div>
                    </td>
                </tr>   

            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr *ngIf="loaded">
                    <td colspan="7">
                        <div  style="height: 50vh; margin-top: 3rem;display: flex;text-align: center;width: 100%;justify-content: center;align-items: center;flex-direction: column; ">
                            <div>
                                <ng-lottie [options]="animationNotFound"  width="15vw" height="15vw"/>
                            </div>
                            <h3 style="color:#ccc;"  >
                                <i>
                                    Nenhum parceiro encontrado
                                </i>
                            </h3>
                        </div>
                    </td>
                </tr>

                <tr *ngIf="!loaded">
                    <td colspan="7">
                        <div class="flex justify-content-center align-items-center w-full" style="height: 50vh;">
                            <p-progressSpinner ariaLabel="loading" />
                        </div>
                    </td>
                </tr>

            </ng-template>

        </p-table>
    </div>

</div>

<p-dialog header="Adicionar parceiro" [(visible)]="displayAddPartner" [modal]="true" [style]="{width: '50vw'}" [closable]="true" [draggable]="false">
    <app-add-partner (onPartnerAdded)="ListPartners(); displayAddPartner=!displayAddPartner;"></app-add-partner>
</p-dialog>